module.exports = __webpack_public_path__ + "static/img/Quicksand-Light.edfae51.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Light.svg
// module id = rVgd
// module chunks = 1